

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axios from 'axios'



if (process.env.NODE_ENV === 'production') {
Vue.prototype.tianYiWebUrl = 'http://wechat.mytyhl.net';
} else {
Vue.prototype.tianYiWebUrl = 'http://ty.mytyhl.net';
}

/*
* axios 配置
*/

axios.defaults.withCredentials = true;

axios.interceptors.response.use(function (response) {

if (response.data.code === 159 && vueIns.$route.fullPath !== '/uc/mobile') {
vueIns.$router.push('/uc/mobile')
} else if (response.data.code === 1000162) {
window.location.href = 'http://wechat.mytyhl.net/wechat/login_middle_ware'
} else if (response.data.code === 33894900) {
if (response.data.message == '') {
response.data.message = '出错啦，请退出页面重试。'
}
vueIns.$router.push('/error/' + response.data.message)
} else if (response.data.code === 33894899) {
vueIns.$vux.alert.show(response.data.message)
}

return response;
}, function (error) {

return Promise.reject(error);
});

Vue.prototype.$http = axios;

Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);
Vue.use(LoadingPlugin);

FastClick.attach(document.body);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
if (to.name === 'cart' || to.name === 'cartOld') {
if (from.fullPath !== '/') {
if (process.env.NODE_ENV === 'production') {
window.location.href = 'http://wechat.mytyhl.net/html/cart'
} else {
window.location.href = 'http://ty.mytyhl.net:8080/html/cart'
}
} else {
next()
}
} else {
next();
}
});


/* eslint-disable no-new */
var vueIns = new Vue({
router,
render: h => h(App),
}).$mount('#app-box');



// WEBPACK FOOTER //
// ./src/main.js